/** Conservative contact reach using only the delayed, visible motion estimate. */
export function contactReach(
  range: number,
  reaction: number,
  anticipation: number,
  velocity: { x: number; z: number },
): number {
  // A partially extrapolated target can already have travelled beyond the believed
  // position. Do not orbit at that stale boundary or spend burst health there.
  const uncertainty = Math.hypot(velocity.x, velocity.z) * reaction * (1 - anticipation);
  return range - Math.min(range * 0.5, Math.max(0, uncertainty));
}
